import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { CalendarSpec } from 'moment';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

/**
 * A Pipe transform to display a contextual date
 * using the the mappings available from moment.
 *
 * Expects translations from calendar.lastDay,
 * calendar.sameDay, calendar.nextDay, calendar.lastWeek,
 * calendar.nextWeek, and calendar.sameElse
 * to be retrievable from the translation service.
 */
@Pipe({
    name: 'calDay',
    pure: false,
})
export class CalendarDayPipe implements PipeTransform
{
    private asyncPipe: AsyncPipe;

    constructor(private translateService: TranslateService, _ref: ChangeDetectorRef) {
        this.asyncPipe = new AsyncPipe(_ref);
    }

    transform(value): string
    {
        const formattedDate = this.translateService.get('calendarDay').pipe(
          map((calendarFormat: CalendarSpec) => moment(value).calendar(null, calendarFormat))
        );
        return this.asyncPipe.transform(formattedDate);
    }
}
